import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidCaretCircleRight",
  "use": "SolidCaretCircleRight-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"SolidCaretCircleRight\"><path d=\"M12 4a8 8 0 110 16 8 8 0 010-16zm-.846 2.878a.245.245 0 00-.294-.04l-.052.04-.625.664c-.08.08-.093.2-.04.294l.04.052L13.992 12l-3.809 3.851c-.08.08-.093.2-.04.294l.04.052.625.925c.08.08.2.092.294.04l.052-.04 4.949-4.949a.244.244 0 00.039-.295l-.04-.051-4.948-4.949z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol